import React from "react";
const HiddenText = ({ htmlTag: CustomTag = "span", text, children }) => {
    return React.createElement(CustomTag, { className: "visuallyhidden" }, text || children);
};
export default HiddenText;
export { HiddenText };
//# sourceMappingURL=index.js.map